module.exports = __webpack_public_path__ + "img/price-click-2.95611c93.jpg";